

export default props=>{

const jsx = (<div className="this-content">
    <style jsx>{`



.this-content{
    width: 460px;

    padding: 45px 60px;
}


.x2{
    float:right;
    margin: -20px -20px 0 0;
}

.logo{
    text-align:center;
}

.title{
    font-size: 16px;
    text-align: center;
    color: #343a40;
}

.button0{
    width: 100%;
    height: 32px;
    text-align: center;
    padding-top: 12px;
    margin: 10px 0;
    vertical-align:middle;

    font-size: 14px;

}

.button0 img{
  vertical-align:middle;
    font-size: 14px;
}

.button1{
    background-color: #325a9f;
    color: white;
}

.button2{
    background-color: #feea0e;
    color: #343a40;
}

.or{
  text-align: center;
}

.label1{} {
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -0.25px;
  color: #868e96;
}

.input1{
    width: 100%;
    /* height: 24px; */
    font-size: 14px;
    color: #adb5bd;
    border: none;
    padding-top: 15px;
}

.comment1{
  font-size: 12px;
  color: #55d5ce;
}
.sentence1{
  font-size: 14px;
  color: #343a40;
  text-align:right;
}
.button3{
    background-color: #212529;
    color: white;
}

.sentence2{
    font-size: 14px;
    color: #343a40;
    text-align:center;
    width: 440px;
    margin-left: -50px;
}
.button4 {
  background-color: #f1f3f5;
  color: #adb5bd;
}


@media all and (max-width:606px) {
    .this-content{
        width: auto;
        padding: 45px 40px;
    }

`}</style>

    <div className="x2" onClick={props.hide}><img src="/assets/images-m/x_2.svg" /></div>

    <div className="">&nbsp;</div>
    <div className="logo"><img src="/assets/images/logo-camscon.svg" /></div>
    <div className="">&nbsp;</div>
    <div className="title">개인정보 보호를 위해 비밀번호를 변경하세요.</div>
    <div className="">&nbsp;</div>
    <div className="">&nbsp;</div>

    <a onClick={() => location.href ="/mypage/ChangePassword"}><div className="button0 button3">변경하러 가기</div></a>
    <a onClick={props.hide}><div className="button0 button4">다음에 변경</div></a>
    <div className="">&nbsp;</div>



</div>);



    return (jsx);
}